/**
 * KanalBadge — the neutral grey channel badge (KANAL column + detail header).
 * E-Mail / Postscan / Portal / Versicherer-API.
 */

import { Badge } from '../../../components/ui/Badge';
import { KANAL_LABEL } from '../constants';
import type { KontrolleKanal } from '../types';

export function KanalBadge({ kanal }: { kanal: KontrolleKanal }) {
  return <Badge variant="neutral">{KANAL_LABEL[kanal]}</Badge>;
}
